/**
 * Displays an impersonation banner when administrators are viewing
 * the application as another user and provides an option to exit
 * impersonation and return to their original account.
 */
import React from "react";
import { Eye } from "@untitledui/icons";
import { useSelector } from "react-redux";

import { stopImpersonation } from "@/services/impersonation";
import {
  selectImpersonation,
} from "@/store/adminSlice";

const ImpersonationBanner: React.FC = () => {
  const impersonation = useSelector(
    selectImpersonation
  );

  if (!impersonation?.isImpersonating) {
    return null;
  }

  const handleExitView = async () => {
    try {
      await stopImpersonation();

      sessionStorage.removeItem(
        "impersonationId"
      );

      window.location.reload();
    } catch (error) {
      console.error(
        "Failed to stop impersonation",
        error
      );
    }
  };

  return (
   <div className="bg-orange-50 border border-orange-200 rounded-xl">
      <div className="px-6 py-4 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
        <div className="flex items-start gap-4">
          <div
            className="
              h-10
              w-10
              rounded-full
              bg-orange-100
              text-orange-600
              flex
              items-center
              justify-center
              shrink-0
            "
          >
            <Eye className="h-5 w-5" />
          </div>

          <div>
            <div className="flex items-center gap-3 flex-wrap">
              <span className="text-sm text-gray-600">
                Viewing as
              </span>

              <span className="font-semibold text-orange-700">
               {impersonation?.effectiveUser?.displayName}
              </span>

              {/* <span
                className="
                  text-xs
                  px-2
                  py-1
                  rounded
                  bg-orange-100
                  text-orange-700
                  font-medium
                "
              >
                VIEW ONLY
              </span> */}
            </div>

            <div className="text-sm text-gray-600 mt-1">
              Signed in as{" "}
              <span className="font-medium">
               {impersonation?.actualUser?.displayName}
              </span>
            </div>
          </div>
        </div>

        <button
          onClick={handleExitView}
          className="
            px-4
            py-2
            rounded-lg
            border
            border-orange-400
            text-orange-700
            font-medium
            hover:bg-orange-100
            transition-colors
          "
        >
          Exit View
        </button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;